import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'shipment-summary',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			binNo:'',
			isLoadingSearch:false,
			bagIdError:false,
			bagIDErrorMSG:'',
			binNoErrorMSG:'',
			binNoError:false,
			binDetails:[],
			showBinDetilsTable:false,
			binAuditLog :[],
			showBinAuditLog: false,
			showBinShipmentDetils:[],
			binShipmentDetails:false,
			hubid:0

		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
		BagCategory: function(isparentbag){
			if (isparentbag==true) {
				return "Parent";
			}else if(isparentbag==false){
				return "Child";
			}
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
	},
	methods: {

		onSubmitSearch: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
				// this.$alertify.success("your message");
			}).catch(() => {
				console.log('errors exist')
				//this.$alertify.error("your message")
			});
		},
			getBinDetailsByBinNo() {
			if (this.binNo == '' || this.binNo == undefined) {
				this.binNoError=true;
				this.binNoErrorMSG = 'Enter Bin No.';
				return false;
			}
			this.binDetails=[];
			this.binNoError=false;
			this.binNoErrorMSG = '';
			this.isLoadingSearch = true;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getBinDetailsByBinNoForReport?binNo=' + this.binNo + '&currentHubId='+this.hubid,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.binDetails = result.data.ResponseData;
						this.showBinDetilsTable=true;
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						this.showBinDetilsTable=false;
						this.showShipmentDetailsTable=false;
						this.showBagdetailsTable=true;
						this.$alertify.error(result.data.ReturnMessage);
						this.binDetails = [];
					}
				}, error => {
					console.error(error)
				})
		},
		showBinLog(binDetails,binid){			
			this.binAuditLog = binDetails.binAuditLog.filter(obj => obj.binid == binid);
			this.showBinAuditLog = true
		},
		closeBinAuditLog()
		{
			this.showBinAuditLog = false
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		showBinShipmentLog(binid){
			this.binShipmentDetails = [];
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getBinShipmentDetailsByBinNo?binNo=' + this.binNo + '&currentHubId='+this.hubid+'&binid='+binid,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.binShipmentDetails = result.data.ResponseData;
						this.showBinShipmentDetils=true;
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.binShipmentDetails = [];
					}
				}, error => {
					console.error(error)
				})
		},
		closeBinShipmentLog()
		{
			this.showBinShipmentDetils = false
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},

		resetForm(){
		 this.isLoadingSearch= false;
		 this.isLoadingSearchBag= false;
		 this.binNoError=false;
		 this.binNoErrorMSG = '';
		 this.showBinDetilsTable=false;
		 this.binNo='';
		 this.$validator.reset();
		 this.showBinShipmentDetils=false;
	 },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BagShipmentQuery/BinShimentSummary/BinShimentSummary.js